/**
 * api end points(URL) will be here
 */
const API_ROOT = process.env.REACT_APP_BACKEND_ENDPOINT as string;
const REGISTRATION_END_POINT = API_ROOT + "/registration"
const RESEND_VERIFICATION = REGISTRATION_END_POINT + "/resend-verification"
const FORGOT_SIGNUP_METHOD = REGISTRATION_END_POINT + "/forgot-signup-method"
const RCIC_REGISTRATION_END_POINT = REGISTRATION_END_POINT + "/rcic"
const SUBSCRIBER_REGISTRATION_END_POINT = REGISTRATION_END_POINT + "/subscriber"
const COUNTRY = API_ROOT + "/country";
const USER = API_ROOT + "/user";
const PROVINCE = API_ROOT + "/province";
const STATE = API_ROOT + "/state";
const LANGUAGE = API_ROOT + "/language";
const LICENSE_TYPE = API_ROOT + "/license-type";
const LOGIN = API_ROOT + "/login";
const LOGIN_EXCHANGE_CODE = API_ROOT + "/login/exchange-code";
const RCIC_PROFILE = API_ROOT + "/rcic-profile";
const RCIC_PROFESSIONAL_ENGAGEMENT = API_ROOT + "/rcic-professional-engagement";
const SUBSCRIBER_PROFILE = API_ROOT + "/subscriber-profile";
const RCIC_SEARCH = API_ROOT + "/rcic/search";
const RCIC_SERVICE_OFFERED = API_ROOT + "/rcic-service-offered";
const RCIC_COUNTRY_SETTINGS = API_ROOT + "/rcic-country-settings";
const RCIC_SERVICE_FEE = API_ROOT + "/service-fee-setup";
const RCIC_LANGUAGE_OFFERED = API_ROOT + "/rcic-language-offered";
const APPOINTMENT_SLOT = API_ROOT + "/appointment-slot";
const APPOINTMENT_SLOT_BOOKING = API_ROOT + "/appointment-slot-booking";
const RCIC_AWAITING_EXTERNAL_PAYMENT_COUNT = APPOINTMENT_SLOT_BOOKING + "/rcic/awaiting-external-payment-count";
const APPOINTMENT_SLOT_MEETING = API_ROOT + "/appointment-slot-meeting";
const CONSULTATION_WORKSPACE = API_ROOT + "/consultation-workspace";
const CONSULTATION_WORKSPACE_MY_REPORTS = API_ROOT + "/consultation-workspace/client/my-reports";
const CONSULTATION_REPORT_PRICE = API_ROOT + "/payment/consultation-report-price";
const CONSULTATION_REPORT_TRIGGER = API_ROOT + "/consultation-report/trigger";
const CONSULTATION_REPORT_GENERATE_PDF = API_ROOT + "/consultation-report/generate-pdf";
const RCIC_MY_REPORT_PURCHASES = API_ROOT + "/payment/my-report-purchases";
const MY_COMMISSION_INVOICE_PURCHASES = API_ROOT + "/payment/my-commission-invoice-purchases";
const MY_PRO_SUBSCRIPTION_PURCHASES = API_ROOT + "/payment/my-pro-subscription-purchases";
const MY_PURCHASE_INVOICE_DOWNLOAD = API_ROOT + "/payment/my-purchases/";
const APPOINTMENT_SLOT_NEXT_AVAILABLE = APPOINTMENT_SLOT + "/next-available-date";
const DOCUMENT_STORE = API_ROOT + "/document/store";
const DOCUMENT_SHARE = API_ROOT + "/document/share";
const DOCUMENT_SIGN = API_ROOT + "/document-sign";
const APPLICANTS = API_ROOT + "/applicants";
const CASE_MANAGEMENT = API_ROOT + "/case-management";
const CASE_MANAGEMENT_DOCUMENTS = API_ROOT + "/case-management-documents";
const VISA_APPLICATION_TYPE = API_ROOT + "/visa-application-type";
const STREAM_DOCUMENTS = API_ROOT + "/stream-documents";
const APPLICANT_VISA_DOCUMENTS = API_ROOT + "/applicant-visa-documents";
const APPLICANT_TYPE = API_ROOT + "/applicant-type";
const FEE_SETUP = API_ROOT + "/fee-setup";
const IRCC_FEE = API_ROOT + "/ircc-fee";
const LEGAL_FEE = API_ROOT + "/legal-fees";
const THIRD_PARTY_FEE = API_ROOT + "/third-party-fee";
const THIRD_PARTY_FEE_PRODUCT = API_ROOT + "/third-party-fee-product";
const APPLICANT_VISA_DOCUMENTS_REMARKS = API_ROOT + "/document-remarks";
const SUBMISSION_LETTER = API_ROOT + "/submission-letter";
const PAYMENT = API_ROOT + "/payment";
const BKASH_PAYMENT = API_ROOT + "/payment/bkash";
const WALLET = API_ROOT + "/wallet/";
const RCIC_WALLET = API_ROOT + "/rcic-wallet";
const RCIC_WALLET_WITHDRAWALS = RCIC_WALLET + "/withdrawals";
const RCIC_WALLET_WITHDRAW = RCIC_WALLET + "/withdraw";
const RCIC_WALLET_PAYOUT_ACCOUNTS = RCIC_WALLET + "/payout-accounts";
const RCIC_WALLET_ADMIN = RCIC_WALLET + "/admin";
const FIREBASE = API_ROOT + "/fcm/";
const NOTIFICATION = API_ROOT + "/notification";
const BANK_INFORMATION = API_ROOT + "/bank-information";
const WITHDRAWAL = API_ROOT + "/withdrawals";
const DIRECT_MESSAGE = API_ROOT + "/direct-messages";

const RCIC_LOGO_SIGNATURE = API_ROOT + "/rcic-logo-sign";

const REVIEWS = API_ROOT + "/reviews";
const MFA_SETUP_DATA = API_ROOT + "/mfa/setup-data";
const MFA_COMPLETE_SETUP = API_ROOT + "/mfa/complete-setup";
const CLIENT_PAYMENTS = API_ROOT + "/payment/my-payments";

const RESCHEDULE_REQUEST = API_ROOT + "/reschedule-request";
const RESCHEDULE_REQUEST_CREATE = RESCHEDULE_REQUEST + "/create";
const RESCHEDULE_REQUEST_RESPOND = RESCHEDULE_REQUEST + "/respond";
const RESCHEDULE_REQUEST_BY_BOOKING = RESCHEDULE_REQUEST + "/by-booking";
const RESCHEDULE_REQUEST_PENDING_RCIC = RESCHEDULE_REQUEST + "/pending-for-rcic";
const ACTION_CENTRE_SUMMARY = API_ROOT + "/action-centre/summary";
const ACTION_CENTRE_ITEM_STATE = API_ROOT + "/action-centre/item-state";
const ACTION_CENTRE_PREFERENCES = API_ROOT + "/action-centre/preferences";
const IMMIGRATION_NEWS = API_ROOT + "/immigration-news";
const BLIFT_PRO_SUBSCRIPTION = API_ROOT + "/blift-pro/subscription";
const PRO_SUBSCRIPTION = API_ROOT + "/pro-subscription";
const SEND_REMINDER = API_ROOT + "/booking/send-reminder";
const AI_SUBSCRIPTION_STATUS = API_ROOT + "/ai/subscription/status";
const AI_BRIEFING = API_ROOT + "/ai/briefing";
const AI_BRIEFING_REFRESH = API_ROOT + "/ai/briefing/refresh";
const AI_INSIGHTS = API_ROOT + "/ai/insights";
const AI_REVENUE_ANALYTICS = API_ROOT + "/ai/revenue-analytics";
const RESCHEDULE_COUNTER_PROPOSE = API_ROOT + "/reschedule-request/counter-propose";

const REFUND_REQUEST = API_ROOT + "/refund-request";
const REFUND_REQUEST_SUBMIT = REFUND_REQUEST + "/submit";
const REFUND_REQUEST_RCIC_INITIATE = REFUND_REQUEST + "/rcic-initiate";
const REFUND_REQUEST_RCIC_HISTORY = REFUND_REQUEST + "/rcic/history";
const REFUND_REQUEST_RCIC_ACTIVE_CHECK = REFUND_REQUEST + "/rcic/active-check";
const REFUND_REQUEST_RCIC_RESPOND = REFUND_REQUEST + "/rcic-respond";
const REFUND_REQUEST_ADMIN_RESPOND = REFUND_REQUEST + "/admin-respond";
const REFUND_REQUEST_MY = REFUND_REQUEST + "/my-requests";
const REFUND_REQUEST_PENDING_RCIC = REFUND_REQUEST + "/pending-for-rcic";
const REFUND_REQUEST_ADMIN_QUEUE = REFUND_REQUEST + "/admin/queue";
const REFUND_REQUEST_BY_BOOKING = REFUND_REQUEST + "/by-booking";
const REFUND_REQUEST_RCIC_CANCEL = REFUND_REQUEST; // append /{id}/rcic-cancel at call site

const PRACTICE_CONTINUITY = API_ROOT + "/practice-continuity";
const PRACTICE_CONTINUITY_MY_REQUESTS = PRACTICE_CONTINUITY + "/my-requests";
const PRACTICE_CONTINUITY_INCOMING = PRACTICE_CONTINUITY + "/incoming";
const PRACTICE_CONTINUITY_COVERAGE_CASES = PRACTICE_CONTINUITY + "/coverage-cases";
const APPOINTMENT_SLOT_BOOKING_COVERAGE_CASES = API_ROOT + "/appointment-slot-booking/coverage-cases";
const RCIC_CO_COUNSEL_SEARCH = API_ROOT + "/rcic-professional-engagement/available-co-counsel";
const RCIC_MY_CLIENTS = API_ROOT + "/rcic-my-clients";

const CLIENT_ACCOUNT_PAYMENT = API_ROOT + "/client-account-payment";
const CLIENT_ACCOUNT_PAYMENT_SUBMIT = CLIENT_ACCOUNT_PAYMENT + "/submit";
const CLIENT_ACCOUNT_PAYMENT_GET = CLIENT_ACCOUNT_PAYMENT + "/get";
const CLIENT_ACCOUNT_PAYMENT_CANCEL = CLIENT_ACCOUNT_PAYMENT + "/cancel";
const CLIENT_ACCOUNT_PAYMENT_SWITCH_TO_BLIFT = CLIENT_ACCOUNT_PAYMENT + "/switch-to-blift";
const CLIENT_ACCOUNT_PAYMENT_SWITCH_TO_CLIENT = CLIENT_ACCOUNT_PAYMENT + "/switch-to-client";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_LIST = CLIENT_ACCOUNT_PAYMENT + "/admin/list";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_DOCUMENT = CLIENT_ACCOUNT_PAYMENT + "/admin/document";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_REVIEW = CLIENT_ACCOUNT_PAYMENT + "/admin/review";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_DETAILS = CLIENT_ACCOUNT_PAYMENT + "/admin";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_APPROVE = CLIENT_ACCOUNT_PAYMENT + "/admin/approve";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_REJECT = CLIENT_ACCOUNT_PAYMENT + "/admin/reject";
const CLIENT_ACCOUNT_PAYMENT_ADMIN_ADD_NOTE = CLIENT_ACCOUNT_PAYMENT + "/admin/add-note";
const CLIENT_ACCOUNT_PAYMENT_CHANGE = CLIENT_ACCOUNT_PAYMENT + "/change";
const PAYMENT_METHOD_LOCK_PERIOD = CLIENT_ACCOUNT_PAYMENT + "/lock-period";
const CLIENT_ACCOUNT_PAYMENT_BOOKING_DETAILS = CLIENT_ACCOUNT_PAYMENT + "/booking";
const COMMISSION_INVOICES = API_ROOT + "/commission/invoices";
const COMMISSION_ADMIN_INVOICES = API_ROOT + "/commission/admin/invoices";
const COMMISSION_INVOICE_DETAIL = API_ROOT + "/commission/invoices/";
const COMMISSION_INVOICE_DOWNLOAD = API_ROOT + "/commission/invoices/";
const COMMISSION_INVOICE_VIEW = API_ROOT + "/commission/invoices/";
const CONFIRM_EXTERNAL_PAYMENT = API_ROOT + "/commission/confirm-external-payment";

export default {
    API_ROOT,
    REGISTRATION_END_POINT,
    RESEND_VERIFICATION,
    FORGOT_SIGNUP_METHOD,
    RCIC_REGISTRATION_END_POINT,
    COUNTRY,
    PROVINCE,
    STATE,
    LANGUAGE,
    LOGIN,
    LOGIN_EXCHANGE_CODE,
    RCIC_SEARCH,
    RCIC_SERVICE_OFFERED,
    RCIC_COUNTRY_SETTINGS,
    RCIC_LANGUAGE_OFFERED,
    APPOINTMENT_SLOT,
    APPOINTMENT_SLOT_BOOKING,
    RCIC_AWAITING_EXTERNAL_PAYMENT_COUNT,
    APPOINTMENT_SLOT_MEETING,
    CONSULTATION_WORKSPACE,
    CONSULTATION_WORKSPACE_MY_REPORTS,
    CONSULTATION_REPORT_PRICE,
    CONSULTATION_REPORT_TRIGGER,
    CONSULTATION_REPORT_GENERATE_PDF,
    RCIC_MY_REPORT_PURCHASES,
    MY_COMMISSION_INVOICE_PURCHASES,
    MY_PRO_SUBSCRIPTION_PURCHASES,
    MY_PURCHASE_INVOICE_DOWNLOAD,
    APPOINTMENT_SLOT_NEXT_AVAILABLE,
    DOCUMENT_STORE,
    DOCUMENT_SHARE,
    DOCUMENT_SIGN,
    RCIC_LOGO_SIGNATURE,
    SUBSCRIBER_REGISTRATION_END_POINT,
    LICENSE_TYPE,
    RCIC_PROFILE,
    RCIC_PROFESSIONAL_ENGAGEMENT,
    SUBSCRIBER_PROFILE,
    APPLICANTS,
    CASE_MANAGEMENT,
    CASE_MANAGEMENT_DOCUMENTS,
    VISA_APPLICATION_TYPE,
    USER,
    STREAM_DOCUMENTS,
    APPLICANT_VISA_DOCUMENTS,
    APPLICANT_TYPE,
    IRCC_FEE,
    FEE_SETUP,
    LEGAL_FEE,
    THIRD_PARTY_FEE,
    THIRD_PARTY_FEE_PRODUCT,
    APPLICANT_VISA_DOCUMENTS_REMARKS,
    RCIC_SERVICE_FEE,
    SUBMISSION_LETTER,
    PAYMENT,
    BKASH_PAYMENT,
    WALLET,
    RCIC_WALLET,
    RCIC_WALLET_WITHDRAWALS,
    RCIC_WALLET_WITHDRAW,
    RCIC_WALLET_PAYOUT_ACCOUNTS,
    RCIC_WALLET_ADMIN,
    FIREBASE,
    NOTIFICATION,
    BANK_INFORMATION,
    WITHDRAWAL,
    DIRECT_MESSAGE,
    REVIEWS,
    MFA_SETUP_DATA,
    MFA_COMPLETE_SETUP,
    CLIENT_PAYMENTS,
    RESCHEDULE_REQUEST,
    RESCHEDULE_REQUEST_CREATE,
    RESCHEDULE_REQUEST_RESPOND,
    RESCHEDULE_REQUEST_BY_BOOKING,
    RESCHEDULE_REQUEST_PENDING_RCIC,
    ACTION_CENTRE_SUMMARY,
    ACTION_CENTRE_ITEM_STATE,
    ACTION_CENTRE_PREFERENCES,
    IMMIGRATION_NEWS,
    BLIFT_PRO_SUBSCRIPTION,
    PRO_SUBSCRIPTION,
    SEND_REMINDER,
    AI_SUBSCRIPTION_STATUS,
    AI_BRIEFING,
    AI_BRIEFING_REFRESH,
    AI_INSIGHTS,
    AI_REVENUE_ANALYTICS,
    RESCHEDULE_COUNTER_PROPOSE,
    REFUND_REQUEST,
    REFUND_REQUEST_SUBMIT,
    REFUND_REQUEST_RCIC_INITIATE,
    REFUND_REQUEST_RCIC_HISTORY,
    REFUND_REQUEST_RCIC_ACTIVE_CHECK,
    REFUND_REQUEST_RCIC_RESPOND,
    REFUND_REQUEST_ADMIN_RESPOND,
    REFUND_REQUEST_MY,
    REFUND_REQUEST_PENDING_RCIC,
    REFUND_REQUEST_ADMIN_QUEUE,
    REFUND_REQUEST_BY_BOOKING,
    CLIENT_ACCOUNT_PAYMENT,
    CLIENT_ACCOUNT_PAYMENT_SUBMIT,
    CLIENT_ACCOUNT_PAYMENT_GET,
    CLIENT_ACCOUNT_PAYMENT_CANCEL,
    CLIENT_ACCOUNT_PAYMENT_SWITCH_TO_BLIFT,
    CLIENT_ACCOUNT_PAYMENT_SWITCH_TO_CLIENT,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_LIST,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_DOCUMENT,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_REVIEW,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_DETAILS,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_APPROVE,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_REJECT,
    CLIENT_ACCOUNT_PAYMENT_ADMIN_ADD_NOTE,
    CLIENT_ACCOUNT_PAYMENT_CHANGE,
    PAYMENT_METHOD_LOCK_PERIOD,
    CLIENT_ACCOUNT_PAYMENT_BOOKING_DETAILS,
    COMMISSION_INVOICES,
    COMMISSION_ADMIN_INVOICES,
    COMMISSION_INVOICE_DETAIL,
    COMMISSION_INVOICE_DOWNLOAD,
    COMMISSION_INVOICE_VIEW,
    CONFIRM_EXTERNAL_PAYMENT,
    REFUND_REQUEST_RCIC_CANCEL,
    PRACTICE_CONTINUITY,
    PRACTICE_CONTINUITY_MY_REQUESTS,
    PRACTICE_CONTINUITY_INCOMING,
    PRACTICE_CONTINUITY_COVERAGE_CASES,
    APPOINTMENT_SLOT_BOOKING_COVERAGE_CASES,
    RCIC_CO_COUNSEL_SEARCH,
    RCIC_MY_CLIENTS,
};
